// extracted by mini-css-extract-plugin
module.exports = {"element":"body-copy_element__3Htbi"};